/**
 * Form validation utilities for PostBoxModal
 */

/**
 * Validate post form data
 * @param {Object} params - Form data parameters
 * @returns {string|null} - Error message or null if valid
 */
export const validatePostForm = ({
  tag,
  issue,
  selectedScale,
  location,
  title,
  content,
  selectedIssueStatus,
}) => {
  if (!tag) return "Please select an action tag";
  if (!issue) return "Please select an issue";
  if (!selectedScale) return "Please select a scale";

  // Improved location validation that checks for selectedLocation object
  if (selectedScale !== 'global' && !location) {
    return "Please select a location";
  }

  if (!title.trim()) return "Please add a title to your post";
  if (!content.trim()) return "Please add content to your post";
  if (title.trim().length < 3) return "Title must be at least 3 characters long";
  if (content.trim().length < 5) return "Content must be at least 5 characters long";
  if (!selectedIssueStatus) return "Please select a status for your post";
  return null;
};
